import React from "react";
import { Link } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { GET_FINANCIALS } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Dashboard = () => {
  const [financials, setFinancials] = useState({});
  const [SidebarState, setSidebarState] = useState(false);
  const [loyaltyPoints, setloyaltyPoints] = useState(0);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
    id: encStorage.getItem("id"),
  };
  const fetchFinancials = async () => {
    const token = encStorage.getItem("token");
    //console.log(token);
    try {
      const response = await axios.post(
        GET_FINANCIALS,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFinancials(
        response.data.financials == null ? {} : response.data.financials
      );
      encStorage.setItem("previous_deposits", response.data.previous_deposits);
      encStorage.setItem("withdrawable_amount", response.data.withdrawable_amount);
      encStorage.setItem("previous_withdrawals", response.data.previous_withdrawals);
      encStorage.setItem("used_margin", response.data.financials.usedMargin);
    } catch (error) {
      setFinancials({});
      console.error("Error fetching financials:", error);
    }
  };
  useEffect(() => {
    fetchFinancials(); // Run on page load
    const interval = setInterval(fetchFinancials, 60000); // Run every 60 seconds
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <div className="container-fluid px-4">
            <div className="d-flex">
              <h3 className="mt-4 w-95">Dashboard</h3>
              <div className="mt-auto me-3">
                <Link
                  to="/deposit/create"
                  className="btn btn-primary"
                  tooltip="New"
                >
                  <span className="d-md-inline">Deposit</span>
                </Link>
              </div>
              <div className="mt-auto me-0">
                <Link
                  to="/withdrawal/create"
                  className="btn btn-primary"
                  tooltip="New"
                >
                  <span className="d-md-inline">Withdraw</span>
                </Link>
              </div>
            </div>
            <div className="w-100 mt-2">
              <div className="border-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Balance</h6>
                          <h6 className="ps-1 fs-4">
                            {financials.balance ?? 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">PNL</h6>
                          <h6 className="ps-1 fs-4">
                            {financials.currentPL ?? 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Credit</h6>
                          <h6 className="ps-1 fs-4">
                            {financials.credit ?? 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Equity</h6>
                          <h6 className="ps-1 fs-4">
                            {financials.equity ?? 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">
                            Intraday Used Margin
                          </h6>
                          <h6 className="ps-1 fs-4">
                            {financials.usedMargin ?? 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">
                            Required Holding Margin
                          </h6>
                          <h6 className="ps-1 fs-4">
                            {financials.holdingMargin ?? 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Free Margin</h6>
                          <h6 className="ps-1 fs-4">
                            {financials.freeMargin ?? 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mt-1">
                      <div className="card bg-brand-white text-light">
                        <div className="card-body">
                          <h6 className="card-title fs-6">Margin Level</h6>
                          <h6 className="ps-1 fs-4">
                            {financials.marginLevel ?? 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4 className="card-title text-center mt-5">
                    Refer a Friend
                  </h4>
                  <p className="text-center mt-1">
                    Share your referral link with friends and earn rewards when
                    they sign up!
                  </p>
                  <div className="row justify-content-center mt-4">
                    <div className="col-md-8">
                      {/* <div className="form-group text-center">
                        <label htmlFor="referral-link">
                          Your Referral Code: {user.id}
                        </label>
                      </div> */}
                      <div className="row">
                        <div className="col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="referral-link"
                            value={
                              "https://markettrade.live/register-now/?code=" +
                              user.id
                            }
                            readOnly
                          />
                        </div>
                        <div className="col-md-3">
                          <button
                            className="btn btn-primary btn-block"
                            onClick={() =>
                              navigator.clipboard.writeText(
                                "https://markettrade.live/register-now/?code=" +
                                user.id
                              )
                            }
                          >
                            Copy Referral Link
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center mt-4">
                    <div className="col-md-8">
                      <h5 className="text-center mb-5">
                        Or <br />
                        Share on Social Media
                      </h5>
                      <div className="d-flex justify-content-between">
                        <a
                          href={
                            "https://www.facebook.com/sharer/sharer.php?u=https://markettrade.live/register-now/" +
                            user.id
                          }
                          target="_blank"
                          className="btn btn-outline-primary me-1"
                        >
                          <i className="fab fa-facebook-f"></i> Share on
                          Facebook
                        </a>
                        <a
                          href={
                            "https://twitter.com/intent/tweet?url=https://markettrade.live/register-now/" +
                            user.id +
                            "&text=Check%20out%20this%20link%20to%20join%20me%20on%20MarketTrade!"
                          }
                          target="_blank"
                          className="btn btn-outline-info me-1"
                        >
                          <i className="fab fa-twitter"></i> Share on Twitter
                        </a>
                        <a
                          href={
                            "https://wa.me/?text=Check%20out%20this%20link%20to%20join%20me%20on%20MarketTrade!%20https://markettrade.live/register-now/" +
                            user.id
                          }
                          target="_blank"
                          className="btn btn-outline-success me-1"
                        >
                          <i className="fab fa-whatsapp"></i> Share on WhatsApp
                        </a>
                        <a
                          href={
                            "https://www.linkedin.com/sharing/share-offsite/?url=https://markettrade.live/register-now/" +
                            user.id
                          }
                          target="_blank"
                          className="btn btn-outline-primary"
                        >
                          <i className="fab fa-linkedin-in"></i> Share on
                          LinkedIn
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="termsModal"
              tabIndex="-1"
              aria-labelledby="termsModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="termsModalLabel">
                      Trading Related Terms & Conditions
                    </h5>
                  </div>
                  <div className="modal-body">
                    <div className="container-fluid h-25">
                      <ul className="list-group">
                        <li className="list-group-item">
                          <strong>
                            1. Operating /Line/Manipulated /Chamka /LTP Trades:
                          </strong>{" "}
                          will be removed anytime.
                        </li>
                        <li className="list-group-item">
                          <strong>2. Scalping:</strong> is not allowed.
                        </li>
                        <li className="list-group-item">
                          <strong>3. BTST/STBT Not Allowed:</strong> Any
                          position opened after 3:00 PM and closed the next day
                          before 9:45 AM will not be allowed. Profits from such
                          trades will be removed by the admin.
                        </li>
                        <li className="list-group-item">
                          <strong>4. Margin Increase:</strong> The margin of a
                          company whose financial results are to be announced
                          tomorrow will be increased to <strong>5%</strong>{" "}
                          before market close.
                        </li>
                        <li className="list-group-item">
                          <strong>5. Dividend/Bonus:</strong> will be adjusted
                          based on the exchange circular.
                        </li>
                        <li className="list-group-item">
                          <strong>
                            6. Arbitrage, Hedging, Jobbing, Algorithmic Jobbing:
                          </strong>{" "}
                          is not allowed. Trades will be removed anytime.
                        </li>
                        <li className="list-group-item">
                          <strong>7. Software Issues:</strong> If unable to
                          close positions due to software issues, contact
                          support via WhatsApp. Positions will be closed at
                          prevailing rates upon receipt of the message.
                          Responsibility lies with the client to inform support.
                        </li>
                        <li className="list-group-item">
                          <strong>8. Order Execution:</strong> All orders will
                          be executed at bid and ask prices.
                        </li>
                        <li className="list-group-item">
                          <strong>9. VPN Usage:</strong> VPN is strictly
                          prohibited. Profits from trades executed using a VPN
                          will be removed.
                        </li>
                        <li className="list-group-item">
                          <strong>10. Group Trading:</strong> Requires prior
                          permission.
                        </li>
                        <li className="list-group-item">
                          <strong>11. Introducer Responsibility:</strong> If the{" "}
                          <strong>Introducer</strong> fails to inform the
                          client, the mediator will be responsible for disputes,
                          and the Introducer will be liable for payments.
                        </li>
                        <li className="list-group-item">
                          <strong>12. Unethical Practices:</strong> Any{" "}
                          <strong>Introducing Broker</strong> found engaging in
                          unethical practices will be terminated or banned.
                        </li>
                        <li className="list-group-item">
                          <strong>13. Account Sharing:</strong> Sharing accounts
                          or allowing managers to engage in unethical practices
                          may lead to account holds and fund blocking.
                        </li>
                        <li className="list-group-item">
                          <strong>14. Cross Orders and IP Restrictions:</strong>{" "}
                          Trades with the same IP or multiple IDs using the same
                          IP are prohibited. Profitable trades may be removed
                          without notice.
                        </li>
                        <li className="list-group-item">
                          <strong>15. Margin Shortfalls:</strong> Clients must
                          ensure timely deposits. Liquidated positions will not
                          be reopened.
                        </li>
                        <li className="list-group-item">
                          <strong>
                            16. Cannot take trades due to stopped prices:
                          </strong>{" "}
                          Please note that whenever the rate of any
                          script/commodity is Stopped from the exchange for 30
                          seconds, the system stops new trades in that script
                          and traders see a message "Trades cannot be taken due
                          to Stopped prices". This prevents any script from
                          trading at wrong rates, it is not the system that
                          stops the rate but the rate is halted at the exchange
                          due to which the rate is halted in our system as well.
                          If the rate is not updated in any script for 30
                          seconds, the system will not accept any trade. This
                          mostly happens in those scrips which have less
                          trading.
                        </li>
                        <li className="list-group-item">
                          <strong>17. Advance Stop Loss not allowed:</strong>{" "}
                          The client can place Stop Loss order only for the
                          positions which are already opened. New positions
                          which are opened using BUY/SELL Stop Loss Orders may
                          be removed any time and any Pending BUY/SELL Stop
                          Order may be cancelled at any time. It is the sole
                          Discretion of the Company.
                        </li>
                        <li className="list-group-item">
                          <strong>18. Bonus/Merge/Demerge/Split:</strong> In
                          case of Bonus/Merge/Demerge/Split in any stock all
                          open positions will be closed at the available prices
                          when market is closing before ex-date.
                        </li>
                        <li className="list-group-item">
                          <strong>19. PNL Calculation:</strong> Profit and loss
                          will be calculated at the available bid and ask prices
                          only but not on previous day closing.
                        </li>
                        <li className="list-group-item">
                          <strong>
                            20. Charts: Screenshots will not be valid.
                          </strong>{" "}
                          Orders are executing of Bid and Ask prices and charts
                          are made on Last Trading Prices (LTP). So Sharing
                          screenshots of chats will be the valid reason for any
                          order executed.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      id="submitTerms"
                    >
                      Agree & Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
